import { useClientFiltering } from './client/useClientFiltering';
import { useClientData } from './client/useClientData';
import { useClientStatus } from './client/useClientStatus';
import { useClientCrud } from './client/useClientCrud';

/**
 * Composite hook for client requests management
 */
export const useClientRequests = () => {
  // Set up client data and filtering
  const { filterStatus, setFilterStatus, getFilteredRequests } = useClientFiltering();
  const { 
    onboardingRequests, 
    setOnboardingRequests, 
    isLoading, 
    activeTab, 
    setActiveTab, 
    loadOnboardingRequests,
    createFilteredLists
  } = useClientData();

  // Apply filters to get the client lists
  const { pendingRequests, verifiedClients, rejectedClients } = 
    createFilteredLists(onboardingRequests, filterStatus);

  // Set up client status management
  const { 
    selectedRequest, 
    isDialogOpen, 
    setIsDialogOpen, 
    newStatus, 
    setNewStatus, 
    isProcessing: statusProcessing, 
    handleRequestAction, 
    updateRequestStatus 
  } = useClientStatus(onboardingRequests, setOnboardingRequests, setActiveTab, loadOnboardingRequests);

  // Set up client CRUD operations (now includes invitation handling)
  const { 
    isAddClientOpen, 
    setIsAddClientOpen, 
    isEditClientOpen, 
    setIsEditClientOpen, 
    clientToEdit, 
    isProcessing: crudProcessing, 
    handleDeleteClient, 
    handleToggleActive, 
    handleAddClient, 
    handleEditClient, 
    updateClient,
    handleSendInvitation,
    handleSendBulkInvitations
  } = useClientCrud(onboardingRequests, setOnboardingRequests, loadOnboardingRequests);

  // Combined processing state
  const isProcessing = statusProcessing || crudProcessing;

  return {
    onboardingRequests: pendingRequests,
    verifiedClients,
    rejectedClients,
    selectedRequest,
    isDialogOpen,
    setIsDialogOpen,
    isAddClientOpen,
    setIsAddClientOpen,
    newStatus,
    setNewStatus,
    isProcessing,
    activeTab,
    setActiveTab,
    filterStatus,
    setFilterStatus,
    isLoading,
    loadOnboardingRequests,
    handleRequestAction,
    updateRequestStatus,
    handleDeleteClient,
    handleToggleActive,
    handleAddClient,
    isEditClientOpen,
    setIsEditClientOpen,
    clientToEdit,
    handleEditClient,
    updateClient,
    handleSendInvitation,
    handleSendBulkInvitations
  };
};
